module.exports = __webpack_public_path__ + "HappyCreditoaddress.031ef7cb.png";